import { request } from '@src/common';
import { makeAutoObservable } from 'mobx';
// import ModelManagementPrivateConfirm from '../modal/modal-management/confirm';

const ALL_IN_ONE_NAME = '一体机';
const OLLAMA_NAME = 'Ollama';
// const OPENAI_NAME = 'OpenAI协议模型';
export const TAB_MODEL_TYPE_MAP = {
  15: 2,
  20: 2,
  30: 3,
  40: 4,
};

export const TAB_MODEL_TAB_MAP = {
  15: '1',
  20: '2',
  30: '3',
  40: '4',
};

export interface ModelItem {
  id: string;
  name: string;
  chat_type?: number;
  apply_model?: string;
  model_type: number;
  model_tab?: string;
  api_url?: string;
  is_preset?: boolean;
  protocol?: number;
  key?: { api_key: string };
  ext?: { reasoning?: boolean; };
  models?: {
    icon?: string;
  }[];
  icon?: string;
}

class ModelStore {
  constructor() {
    makeAutoObservable(this);
  }
  modeList: ModelItem[] = [];
  allModeList: ModelItem[] = [];
  activeModel?: ModelItem = null;
  fromTab = 20;

  sortModelList = () => {
    const localModes = [OLLAMA_NAME, ALL_IN_ONE_NAME];
    // 将 Ollama 模型移到末尾
    this.modeList.sort((a, b) => {
      const aIndex = localModes.indexOf(a.name);
      const bIndex = localModes.indexOf(b.name);
      return aIndex - bIndex;
    });
  };

  // 更新列表数据
  setModelFirmList = (modelInfo: ModelItem, isOllman: boolean) => {
    this.modeList = this.modeList.map(item => {
      if (item.id === modelInfo.id && isOllman) {
        return modelInfo
      }
      if (item.id === modelInfo.id && !item.is_preset) {
        return modelInfo;
      }
      return item;
    })
    this.allModeList = this.allModeList.map(item => {
      if (item.id === modelInfo.id && isOllman) {
        return modelInfo
      }
      if (item.id === modelInfo.id && !item.is_preset) {
        return modelInfo;
      }
      return item;
    })
    this.setActiveModel(modelInfo);
  };

  
  // 如果没有私有模型 就自动创建一个
  initPrivateModel = async (item: ModelItem) => {
    // const noExample = !this.modeList.find(item => item.model_type === 4);
    const ollamaIndex = this.modeList.findIndex(oi => oi.model_type === 3);
    if (ollamaIndex !== -1) {
      const ollamaItem = this.modeList[ollamaIndex];
      if (!ollamaItem.models?.[0]?.icon && item?.is_preset) {
        ollamaItem.models =  [{
          ...ollamaItem,
          icon: item?.icon || 'https://p1.ssl.qhimg.com/t110b9a930130b6f57efcd65b9a.jpg',
        }];
      }
    }
    // const noAllInOne = !this.modeList.find(item => item.name === ALL_IN_ONE_NAME);
    const promises = [];
    const params: {
      name: string;
      model_type: number;
      protocol: number;
    }[] = [];
    // if (noExample) {
    //   names.push(OPENAI_NAME);
    //   promises.push(
    //     request.post('/user/firm/custom', {
    //       name: OPENAI_NAME,
    //       protocol: 1
    //     }, {
    //       dataIsJson: true,
    //     }),
    //   );
    // }
    // 创建私有模型 is_preset 为 true 为预设模型
    if (ollamaIndex === -1 && item?.is_preset && item.model_type === 3) {
      const param = {
        name: item?.name || OLLAMA_NAME,
        model_type: 3,
        protocol: 1,
      };
      params.push(param);
      promises.push(
        request.post('/user/firm/custom', param, {
          dataIsJson: true,
        } as unknown),
      );
    }
    // if (noExample && this.fromTab === 40) {
    //   const param = {
    //     name: ALL_IN_ONE_NAME,
    //     model_type: 4,
    //     protocol: 1
    //   };
    //   params.push(param);
    //   promises.push(
    //     request.post('/user/firm/custom', param, {
    //       dataIsJson: true,
    //     } as unknown),
    //   );
    // }

    const ress = await Promise.allSettled(promises);

    ress.forEach((res, index) => {
      if (res.status === 'fulfilled' && res.value.code === 0) {
        this.setPrivateModel({
          name: params[index].name,
          protocol: 1,
          id: res.value.data.firm_id,
          model_type: params[index].model_type,
          models: [{
            icon: item?.icon || 'https://p1.ssl.qhimg.com/t110b9a930130b6f57efcd65b9a.jpg'
          }]
        }, true);
      }
    });
    
    this.sortModelList();
  };

  delModelFirm = (id: string) => {
    this.allModeList = this.allModeList.filter(item => {
      return item.id !== id
    });
    this.modeList = this.modeList.filter(item => {
      return item.id !== id
    })
    if (id === this.activeModel?.id) {
      this.setActiveModel(this.modeList[0]);
    }
  };

  addModelFirmList = (modelInfo: ModelItem, noFocus = false) => {
    const existingIndex = this.modeList.findIndex(item => item.id === modelInfo.id);
    if (existingIndex !== -1) {
      // 如果找到相同 id，更新该项
      this.modeList[existingIndex] = modelInfo;
      this.allModeList[existingIndex] = modelInfo;
    } else {
      // 如果没找到，在头部添加
      this.modeList = [modelInfo, ...this.modeList];
      this.allModeList = [modelInfo, ...this.allModeList];
    }
    if (!noFocus) {
      // 更新当前选中的模型
      this.setActiveModel(modelInfo);
    }
  };

  setPrivateModel = (model: ModelItem, noFocus = false) => {
    this.addModelFirmList(model, noFocus);
  };

  setActiveModel = (model: ModelItem) => {
    this.activeModel = model;
  };

  autoFocus = (id?: string) => {
    // 传入的有id 则选中当前id
    if (id) {
      const modelinfo = this.modeList.find(item => item.id === id)
      this.setActiveModel(modelinfo);
    } else {
       if (this.fromTab === 20 || this.fromTab === 30 || this.fromTab === 40) {
          let model;
          if (this.fromTab === 20) {
            model = this.modeList.find((item) => item.model_type === 2);
          } else if (this.fromTab === 40) {
            model = this.modeList.find((item) => item.model_type === 4);
          } else {
            model = this.modeList.find((item) => item.model_type === 3);
          }
          if (model) {
            this.setActiveModel(model);
          }
        } else {
          this.setActiveModel(this.modeList[0]);
        }
    }
    // if (this.fromTab === 30) {
    //   ModelManagementPrivateConfirm.show();
    // }
    // if (this.fromTab === 20 || this.fromTab === 30 || this.fromTab === 40) {
    //   let model;
    //   if (this.fromTab === 20) {
    //     model = this.modeList.find((item) => item.model_type === 2);
    //   } else if (this.fromTab === 40) {
    //     model = this.modeList.find((item) => item.model_type === 4 && !item.api_url);
    //   } else {
    //     model = this.modeList.find((item) => item.model_type === 3 && item.name !== OLLAMA_NAME);
    //   }
    //   if (model) {
    //     this.setActiveModel(model);
    //   }
    //   // this.fromTab = null;
    // } else if (this.activeModel?.id) {
    //   const activeObj = this.modeList.find((item) => item.id === this.activeModel.id)
    //   if ([OLLAMA_NAME, ALL_IN_ONE_NAME, OPENAI_NAME].includes(activeObj.name)) {
    //     this.setActiveModel(this.modeList[0]);
    //   } else {
    //     this.setActiveModel(activeObj);
    //   }
    // } else {
    //   this.setActiveModel(this.modeList[0]);
    // }
  };
  
  isPreset = (id: string) => {
    const presetList = this.allModeList.filter(item => item.is_preset);
    return presetList.some(item => item.id === id);
  }

  setFromTab = (tab: number) => {
    this.fromTab = tab;
    const type = TAB_MODEL_TYPE_MAP[tab];
    const list = this.allModeList.filter(item => item.model_type === type);
    
    // 当模型类型是私有模型或一体机时，进行ID去重处理
    if (type === 4 || type === 3) {
      // 使用Map进行去重，key为id，value为模型对象
      const uniqueMap = new Map();
      // 首先按is_preset进行排序，让is_preset=false的排在前面
      const sortedList = [...list].sort((a, b) => {
        // 如果a的is_preset为false而b的为true，a排在前面
        if (a.is_preset === false && b.is_preset === true) return -1;
        // 如果a的is_preset为true而b的为false，b排在前面
        if (a.is_preset === true && b.is_preset === false) return 1;
        // 其他情况保持原顺序
        return 0;
      });
      // 遍历排序后的列表，将每个ID的第一个出现的项目（优先是is_preset=false的）加入Map
      sortedList.forEach(item => {
        if (!uniqueMap.has(item.id)) {
          uniqueMap.set(item.id, item);
        }
      });
      // 将Map转回数组
      const uniqueList = Array.from(uniqueMap.values());
      this.modeList = uniqueList;
    } else {
      this.modeList = [...list.filter((item) => item.model_tab === TAB_MODEL_TAB_MAP[tab])];
    }
    this.sortModelList();
  };

  getModelFirmList = async (id: string, fromTab: number) => {
    request
      .get('/model/firm')
      .then(async (res) => {
        const list = res.data || [];
        this.allModeList = [...list];
        this.setFromTab(fromTab);
        // await this.initPrivateModel(item);
        this.autoFocus(id);
      });
  };
}

export default new ModelStore();